// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2tKK7","containerItemsCenter":"Skeleton_containerItemsCenter__1CRcl"};